import type { LocalisationObject } from "@app/scripts/types";

export const getLocalisation = (): LocalisationObject | null => {
  try {
    const element = document.querySelector("[data-localisation]");
    if (!element) return null;

    return JSON.parse(element.innerHTML) as LocalisationObject;
  } catch (error) {
    console.error("Error parsing localisation:", error);
    return null;
  }
};
